import React from 'react';
import api from 'api';
import { DropdownSelector, CheckBox } from 'hyperdb-utils';

class TemplateSelector extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.api.emailTemplate.getData({
      url: '/list-by-type',
      propName: 'templatesByType',
    });
  }
  render() {
    return (
      <div>
        <DropdownSelector
          label={ this.props.labelType || 'Type' }
          name="type"
          options={ this.typesOptions(this.props.templatesByType || []) }
          value={ this.props.type }
          onChange={ this.handleChange.bind(this, 'type') }
        />
        {/*
          <CheckBox
            label="Use predefined template"
            name="useDefinedTemplate"
            checked={ this.props.useDefinedTemplate }
            onChange={ this.handleChange.bind(this, 'use') }
          />
        */}
        {
          this.props.type // !this.props.useDefinedTemplate
            ? <DropdownSelector
                label={ this.props.labelTemplate || 'Template' }
                name="template"
                options={ this.templatesOptions(this.props.type) }
                value={ this.props.template }
                onChange={ this.handleChange.bind(this, 'template') }
              />
            : null
        }
      </div>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    if (attributeName === 'type') {
      this.props.onChangeTemplateType(value);
      // this.props.onChangeTemplate(0);
    }
    if (attributeName === 'template') {
      this.props.onChangeTemplate(value);
    }
    /* if (attributeName === 'use') {
      const useDefinedTemplate = !this.props.useDefinedTemplate;
      this.props.onChangeChooseDefinedTemplate(useDefinedTemplate);
    }*/
  }
  typesOptions(templatesByType) {
    return templatesByType
      .filter(t => {
        if (!this.props.filterCodes) return t;
        return this.props.filterCodes.includes(t.code);
      })
      .map(t => {
        return { name: `${t.code} - ${t.type}`, value: t.code };
      });
  }
  templatesOptions(type) {
    if (!type) return [];
    const defaultTemplate = (this.props.templatesByType || []).find(t => String(t.code) === String(type));
    if (!defaultTemplate) return [];
    return defaultTemplate.templates.map(t => {
      return { name: t.name, value: t.id };
    });
  }
}

TemplateSelector.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default api.connect(TemplateSelector, 'emailTemplate');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/template/containers/TemplateSelector.jsx